import React from 'react';
import AusenciasPage from './ausencias/AusenciasPage';

const IncapacidadesPage = () => <AusenciasPage tipo="incapacidad" />;

export default IncapacidadesPage;
